module.exports = __webpack_public_path__ + "70c1d60052efd0e439da56bfc69d3cc7.MP3";